module.exports = __webpack_public_path__ + "img/1.3d0c8526.svg";